import { Injectable } from '@angular/core';
import { LoadingController } from '@ionic/angular';

@Injectable({
  providedIn: 'root',
})
export class LoadingService {
  loadingAlert: HTMLIonLoadingElement;

  constructor(private loadingController: LoadingController) {}

  async showLoadingAlert(messageText?: string) {
    this.loadingAlert = await this.loadingController.create({
      message: messageText ? messageText : 'Proszę czekać',
    });
    await this.loadingAlert.present();
  }

  closeLoadingAlert() {
    setTimeout(() => {
      this.loadingAlert.dismiss();
    }, 500);
  }
}
